import React from "react";
import { Button } from "../ui/button";
import { Smartphone, Search, MessageCircle, Database, Bell, Palette } from "lucide-react";

const AppSection = () => {
  const features = [
    {
      icon: Search,
      title: "Mobile-Friendly Property Browsing",
      description: "with search and filter."
    },
    {
      icon: MessageCircle,
      title: "In-App Chat",
      description: "to answer questions instantly."
    },
    {
      icon: Database,
      title: "Lead Capture & Sync:",
      description: "Every inquiry flows straight into your CRM for tracking and follow-up."
    },
    {
      icon: Bell,
      title: "Push Notifications",
      description: "for new listings, price drops, or open houses."
    },
    {
      icon: Palette,
      title: "Branded Experience",
      description: "to keep your agency front and center."
    }
  ];

  const handleGetStarted = () => {
    document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 bg-gray-900">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Side - Content */}
          <div>
            <h3 className="text-yellow-400 text-lg font-semibold mb-4">
              Your Own Branded App for Clients
            </h3>
            
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Give Clients the Ultimate{" "}
              <span className="text-transparent bg-gradient-to-r from-yellow-400 to-yellow-600 bg-clip-text">
                Mobile Experience
              </span>
            </h2>

            <p className="text-gray-300 text-lg mb-8 leading-relaxed">
              Give buyers and sellers an easy way to connect with you, browse listings, and chat with your assistant—all from their phone.
            </p>

            {/* Features List */}
            <div className="space-y-4 mb-8">
              {features.map((feature, index) => {
                const IconComponent = feature.icon;
                return (
                  <div key={index} className="flex items-start space-x-4">
                    <div className="w-8 h-8 bg-yellow-400 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <IconComponent className="w-4 h-4 text-black" />
                    </div>
                    <div>
                      <span className="text-white font-semibold">{feature.title}</span>
                      <span className="text-gray-400 ml-2">{feature.description}</span>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* CTA Button */}
            <Button
              onClick={handleGetStarted}
              className="bg-yellow-400 hover:bg-yellow-500 text-black font-semibold px-8 py-3 text-lg transition-all duration-300 transform hover:scale-105"
            >
              Get Started Now
            </Button>
          </div>

          {/* Right Side - Mobile App Image */}
          <div className="relative">
            <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-lg p-2 border border-gray-700">
              <img 
                src="https://customer-assets.emergentagent.com/job_944c48ee-4bbe-46a0-a183-10e223961614/artifacts/ck30dub1_ChatGPT%20Image%20Sep%2024%2C%202025%2C%2011_17_10%20PM.png"
                alt="Golden Cortex Mobile App Preview"
                className="w-full h-auto rounded-lg object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppSection;